<template>
    <select v-model="vmodel" class="custom-select" :name="name">
        <option value="" disabled selected>{{ placeholder }}</option>
        <option v-for="({ value, text }, index) in options" :key="`dropdown-${name}-${index}`" :value="value">
            {{ text }}
        </option>
    </select>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// TODO: Replace this component usage with CSelect component
const props = withDefaults(
    defineProps<{
        placeholder?: string;
        options: { value: unknown; text: string }[];
        value: unknown;
        name: string;
    }>(),
    {
        placeholder: 'Select an option'
    }
);

const emit = defineEmits(['input']);

const vmodel = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
    }
});
</script>

<style scoped>
.custom-select {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    vertical-align: middle;
    background: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    appearance: none;
}

.custom-select option {
    display: block;
    min-height: 1.2em;
    padding: 0px 2px 1px;
    white-space: nowrap;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
}
</style>
